import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {

  const [searchResults, setSearchResults] = useState([]);
  const [searchAcctName, setSearchAcctName] = useState();

  useEffect(() => {
    
    const fetchLists = async () => {
      try {

//        const response = await axios.get(`${BASE_URL}/api/get_account_edit`);
        const response = await axios.get(`${BASE_URL}/api/get_account_edit`, {params: {p_AcctName : ''}});

        setSearchResults(response.data);


      } catch (err) {
        console.error("Populate error:", err);
      }
    };

    fetchLists();

  }, []);

  // const handleRowClick = async (rowData) => {
  // };

  const handleSearch = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get_account_edit`, {params: {p_AcctName : searchAcctName}});

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Select Ledger Account</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3 d-flex gap-3">
          <Form.Group>
            <Form.Label>Account Name</Form.Label>
            <Form.Control type="text" name="searchAcctName" value={searchAcctName}
              onChange={(e) => setSearchAcctName(e.target.value)} style={{ minWidth: '350px' }}
            />
          </Form.Group>

          <div className="align-self-end">
            <Button variant="primary" onClick={handleSearch}>Search</Button>
          </div>
        </Form>

        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '30%', textAlign: 'left' }}>Account Name</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Ledger Type</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="3" className="text-center">No data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.acct_name}</td>
                    <td style={{ textAlign: 'left' }}>{row.ledger_type}</td>
                    <td style={{ textAlign: 'left' }}>{row.acct_status}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAllotParkModal;
